var map = {
	"./1.png": 1905,
	"./10.png": 3301,
	"./11.png": 2202,
	"./12.png": 312,
	"./2.png": 3796,
	"./3.png": 9350,
	"./4.png": 4247,
	"./5.png": 8142,
	"./6.png": 9744,
	"./7.png": 1169,
	"./8.png": 6428,
	"./9.png": 545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9689;